<template>
  <card header-classes="bg-transparent">
    <b-row align-v="center" slot="header">
      <b-col>
        <h4 class=" ls-1 mb-1 nowrap">{{title}}</h4>
      </b-col>
      <b-col class="text-right nowrap" v-if="$slots.icon || icon">
          <span class="h6 font-weight-bold mb-0 hand" v-if="cTitle">
            <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="graphChangeTab( cTitle)"
                         v-bind:class="btnActivated === cTitle ? 'bg-warning text-white' : ''"
            >{{cTitle}}</base-button>
          </span>
          <span class="h6 font-weight-bold mb-0" v-if="dTitle">
            <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="graphChangeTab( dTitle)"
                         v-bind:class="btnActivated === dTitle ? 'bg-warning text-white' : ''"
            >{{dTitle}}</base-button>
          </span>
          <span class="h6 font-weight-bold mb-0" v-if="mTitle">
            <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="graphChangeTab( mTitle)"
                         v-bind:class="btnActivated === mTitle ? 'bg-warning text-white' : ''">
              {{mTitle}}</base-button>
          </span>
          <span class="h6 font-weight-bold mb-0 mr-1" v-if="yTitle">
            <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="graphChangeTab( yTitle)"
                         v-bind:class="btnActivated === yTitle ? 'bg-warning text-white' : ''">
              {{yTitle}}</base-button>
          </span>
        <slot name="icon" class="pl-2 ">
          <b-icon
              icon="question-circle"
              variant="orange"
              class="mr-1 vertical-align-35"
              v-b-tooltip.hover.top="tooltip">
          </b-icon>
        </slot>
        <slot name="icon" class="pl-2">
          <b-icon
              :icon="icon1"
              variant="orange"
              class="vertical-align-35"
              @click="dataVolumeTrendToggle()"
              v-b-tooltip.hover.top="'Click here to enable or disable this item'"
          ></b-icon>
        </slot>
      </b-col>
    </b-row>

    <transition name="slide-fade">
      <b-row v-if="toggleStatus">
        <div class="text-center w-100">
          <b-icon icon="three-dots"
                  class="text-center " animation="cylon"
                  font-scale="4"
                  v-if="loadingStatus"></b-icon>
        </div>
        <b-col xl="12" v-if="!loadingStatus">
          <line-chart
            :height="350"
            ref="bigChart"
            :chart-data="bigLineChart.chartData"
            :extra-options="bigLineChart.extraOptions"
          >
          </line-chart>
        </b-col>
        <b-col xl="12" class="mt-4"  v-if="!loadingStatus">
          <DataVolumeProgress></DataVolumeProgress>
        </b-col>
      </b-row>
    </transition>
  </card>
</template>

<script>
    import cardOpenStatusDirective from "../../../common/directive/card-open-status-directive";
    import * as chartConfigs from "../../../components/Charts/config";
    import LineChart from "../../../components/Charts/LineChart";
    import {Card} from "element-ui";
    import DataVolumeProgress from "./DataVolumeProgress";

    export default {
        name: "DataVolumeDetail",
      components: {
        DataVolumeProgress,
        Card,
        LineChart,
      },
      props: {
        type: {
          type: String,
          default: 'primary'
        },
        icon: String,
        title: String,
        cTitle: String,
        dTitle: String,
        mTitle: String,
        yTitle: String,
        iconClasses: [String, Array],
        chartXLabel: Array,
        chartDataVolume: Array,
        tooltip: String,
      },
      data() {
        return {
          loadingStatus: true,
          btnActivated: 'Current',
          toggleStatus: false,
          icon1: 'arrow-right-square',
          downIcon: 'arrow-down-square',
          rightIcon: 'arrow-right-square',
          bigLineChart: {
            allData: [
              []
            ],
            activeIndex: 0,
            chartData: {
              datasets: [
                {
                  label: 'Performance',
                  backgroundColor: 'lightGray',
                  lineWidth: '1',
                  data: [],
                }
              ],
              labels: [],
            },
            extraOptions: chartConfigs.lineChartOptionsBlue,
          }
        }
      },

      mounted() {
        this.getCardStatus();

        this.$root.$on('dataVolumeTrendByPeriod', (label, data) => {
          this.loadingStatus = false;
          data = data.map(e => e.replace(/,/g, ''));
          this.bigLineChart.chartData.datasets[0] = {
            data: data,
            backgroundColor: '#ADD8E6',
            borderWidth: '2',
            borderColor: '#1E90FF',
            drawTicks: true,
            pointStyle: 'circle',
            radius: 3,
            pointBackgroundColor: '#87CEFA',
            pointBorderColor: '#6495ED'
          };
          this.bigLineChart.chartData = {
            ...this.bigLineChart.chartData, labels: label,
          };
        });
      },

      methods: {
        getCardStatus() {
          let cardStatus = cardOpenStatusDirective.getOpenCardStatus()['dataVolume-chart-collapse'];
          if (cardStatus) {
            this.icon1 = this.downIcon;
            this.toggleStatus = cardStatus;
          }
        },

        graphChangeTab(title) {
          this.loadingStatus = true;
          this.$emit('graphChangeTabByIMSI', title);
          this.btnActivated = title;
        },

        dataVolumeTrendToggle() {
          let status = cardOpenStatusDirective.setDataVolumeChartStatus();
          if (status) {
            this.toggleStatus = !this.toggleStatus;
            if (this.toggleStatus) {
              this.icon1 = this.downIcon;
            } else {
              this.icon1 = this.rightIcon
            }
            this.$root.$emit('dataVolumeTrendByPeriodOpen', this.btnActivated)
          }
        }
      }
    }
</script>
